import {
  Button,
  Col,
  Descriptions,
  Layout,
  message,
  notification,
  Popconfirm,
  Row,
  Space,
  Table,
  Tooltip,
} from 'antd';
import BreadcrumbContainer from '../../../containers/Breadcrumb';
import React, { useEffect, useState } from 'react';
import Title from 'antd/es/typography/Title';
import INTERNAL_LINKS from '../../../enums/InternalLinks';
import { catchException } from '../../../utils/helpers/helpers';
import { getUnitForm } from '../../../api/module/unit_form';
import SpinLoad from '../../../components/SpinLoad';
import { createFillOutForm, queryFillOutForm, updateFillOutForm } from '../../../api/module/fill_out_form';
import {
  CheckOutlined,
  CloseOutlined,
  DeleteFilled,
  EditFilled,
  PlusCircleOutlined,
  WarningOutlined,
} from '@ant-design/icons';
import MESSAGES from '../../../enums/Messages';
import { multipleForm } from '../../../api/module/forms';
import { queryQuestionsGridFields, queryQuestionsGridValues } from '../../../api/module/question';
import { exception } from 'react-ga';
import dayjs from 'dayjs';

const { Content } = Layout;

export default function FormFillOutSummary({ id, history }) {
  const [unitFormData, setUnitFormData] = useState({
    unidad_detalle1: undefined,
    unidad_detalle2: undefined,
    unidad_detalle3: undefined,
    unidad_detalle4: undefined,
    formulario_codigo: undefined,
    formulario_categoria: undefined,
    formulario_nombre: undefined,
    formulario_multiple: undefined,
  });
  const [loadingInfo, setLoadingInfo] = useState(false);
  const [loadingFillOut, setLoadingFillOut] = useState(false);
  const [columnsFillOutForm, setColumnsFillOutForm] = useState([]);
  const [loadingSummary, setLoadingSummary] = useState(false);
  const [dataFillOut, setDataFillOut] = useState([]);
  const [disableCreation, setDisableCreation] = React.useState(false);
  const [messageApi, contextHolder] = message.useMessage();

  const breadcrumbItems = [
    {
      text: 'Formularios - Diligenciamiento',
      to: `${INTERNAL_LINKS.FORMS_FILL_OUT}`,
    },
    {
      text: 'Formulario - Resumen',
    },
  ];

  const actionsFillOutForm = {
    title: 'Acciones',
    dataIndex: 'accion',
    align: 'center',
    fixed: 'right',
    width: '100',
    render: (_, record) => (
      <Space>
        <Tooltip title="Editar Diligenciamiento" placement="top">
          <EditFilled
            onClick={() => editFillOut(record.id)}
            disabled={record.estado === 'Finalizado'}
            style={{ fontSize: '16px', color: 'green' }}
          />
        </Tooltip>
        {/* TODO - include fill out view page */}
        {/*<Tooltip title="Ver Diligenciamiento" placement="top">*/}
        {/*  <EyeFilled*/}
        {/*    onClick={() => viewFillOut(record.id)}*/}
        {/*  />*/}
        {/*</Tooltip>*/}
        <Tooltip title="Eliminar Diligenciamiento" placement="top">
          <Popconfirm
            title="Eliminar Diligenciamiento"
            description="Está seguro de eliminar este diligenciamiento ?"
            onConfirm={() => deleteFillOut(record.id)}
            icon={<WarningOutlined style={{ color: 'red' }} />}>
            <DeleteFilled style={{ fontSize: '16px', color: 'red' }} />
          </Popconfirm>
        </Tooltip>
      </Space>
    ),
  };

  const columnsBase = [
    {
      title: 'Estado',
      dataIndex: 'estado',
      key: 'estado',
      fixed: 'left',
      align: 'center',
    },
    {
      title: 'Fecha de Creación',
      dataIndex: 'created_at',
      key: 'created_at',
      fixed: 'left',
      align: 'center',
      render: (_, record) => (dayjs(record.created_at, 'YYYY-MM-DD HH:mm:ss').toDate().toLocaleString()),
    },
    {
      title: 'Fecha de Actualización',
      dataIndex: 'updated_at',
      key: 'updated_at',
      fixed: 'left',
      align: 'center',
      render: (_, record) => (dayjs(record.updated_at, 'YYYY-MM-DD HH:mm:ss').toDate().toLocaleString()),
    },
  ];

  const fetchUnitForm = async () => {
    try {
      setLoadingInfo(true);
      return await getUnitForm(id);
    } catch (error) {
      catchException(error);
    } finally {
      setLoadingInfo(false);
    }
  };

  const fetchFillOut = async () => {
    try {
      return await queryFillOutForm({
        'filter[unidad_formulario]': id,
        'filter[estado__not]': 'Borrado',
      }, 1, 100);
    } catch (error) {
      catchException(error);
    }
  };

  const fetchFillOutFormGridFields = async () => {
    try {
      let dynamicFields = await queryQuestionsGridFields({ 'formulario_unidad': id });
      dynamicFields.data.results.forEach(field => {
        columnsBase.push({
          title: field.nombre,
          dataIndex: 'grid' + field.id,
          key: 'grid' + field.id,
          align: 'center',
        });
      });
      columnsBase.push(actionsFillOutForm);
      return columnsBase;
    } catch (error) {
      catchException(error);
    }
  };

  const fetchFillOutFormGridValues = async () => {
    try {
      return await queryQuestionsGridValues({ 'formulario_unidad': id });
    } catch (error) {
      catchException(error);
    }
  };

  const mapValue = (value) => {
    let v = null;
    if (value !== null && value !== undefined) {
      switch (value.tipo_nombre) {
        case 'Selección Única':
          v = value.option;
          break;
        case 'Selección Multiple':
          v = JSON.stringify(value.string_value);
          break;
        case 'Fecha':
          v = value.date_value;
          break;
        case 'Hora':
          v = value.time_value;
          break;
        case 'Número':
          v = value.int_value;
          break;
        case 'Fecha y Hora':
          v = value.datetime_value;
          break;
        case 'Texto Largo':
          v = value.text_value;
          break;
        case 'Booleano':
          v = (value.bool_value === true) ? <CheckOutlined /> : <CloseOutlined />;
          break;
        case 'Número Decimal':
          v = value.float_value;
          break;
        default:
          v = value.string_value;
          break;
      }
    }
    return v;
  };

  const loadFillOutFormData = () => {
    try {
      setLoadingFillOut(true);
      fetchFillOutFormGridFields().then(c => {
        setColumnsFillOutForm(c);
      });
      fetchFillOut().then(d => {
        let data = d.data.results;
        fetchFillOutFormGridValues().then(v => {
          d.data.results.forEach((row, index) => {
            v.data.results.forEach((rowData) => {
              if (row.id === rowData.diligenciamiento) {
                let key = `grid${rowData.id}`;
                data[index][key] = mapValue(rowData);
              }
            });
          });
          setDataFillOut(data);
        });
      });
    } catch (error) {
      catchException(error);
    } finally {
      setLoadingFillOut(false);
    }
  };

  const deleteFillOut = async (id) => {
    try {
      await updateFillOutForm(id, {"estado": 'Eliminado'});
      notification.success({
        message: 'Eliminación de Diligenciamiento',
        description: 'El diligenciamiento fue eliminado exitosamente.',
        duration: 4,
      });
      loadFillOutFormData();
    } catch (e) {
      exception(e);
    }
  };

  const viewFillOut = async (id) => {
    // TODO - crear vista para ver el diligenciamiento
  };

  const editFillOut = (fillOutFormId) => {
    history.push(`${INTERNAL_LINKS.FILL_OUT_FORM_EDIT}/${fillOutFormId}`);
  };

  const createFillOut = async () => {
    setDisableCreation(true);
    let key = 'msg';
    messageApi.open({
      key: key,
      type: 'loading',
      content: 'Creando nuevo diligenciamiento...',
    });
    try {
      let multiple = await multipleForm({ 'unidad_formulario': id });
      if (multiple.data.results[0]?.multiple === true ||
        (multiple.data.results[0]?.multiple === false && multiple.data.results[0]?.diligenciados === 0)) {
        let data = {
          'unidad_formulario': id,
          'estado': 'Creado',
        };
        let fillOut = await createFillOutForm(data);
        messageApi.open({
          key,
          type: 'success',
          content: 'El diligenciamiento se ha creado exitosamente!',
          duration: 2,
        }).then(r => {
          history.push(`${INTERNAL_LINKS.FILL_OUT_FORM_EDIT}/${fillOut.data.id}`);
        });
      } else {
        notification.error({
          message: 'Multiples Diligenciamientos',
          description: 'No es posible crear mas de un diligenciamiento al presente formulario.',
          duration: 3,
        });
      }
    } catch (e) {
      messageApi.error({
        key: key,
        type: 'error',
        content: e.message,
        duration: 3,
      }).then(r => {
        notification.error({
          message: MESSAGES.ERROR_MSG,
          description: MESSAGES.DESC_ERROR_POST_MSG,
          duration: 3,
        });
      });
    } finally {
      setDisableCreation(false);
    }
  };

  useEffect(() => {
    fetchUnitForm().then(r => {
      setUnitFormData(r.data);
    });
    loadFillOutFormData();
  }, []);

  return (
    <Content>
      <Row>
        <Col span={24}>
          <BreadcrumbContainer items={breadcrumbItems} />
        </Col>
        <Col span={24}>
          <Title className={'text-uppercase'} level={2}>
            Formulario - Resumen
          </Title>
        </Col>
      </Row>
      <Row>
        <Col span={24}>
          <SpinLoad loading={loadingInfo}>
            <Descriptions
              bordered
              column={4}
              title="Información Unidad"
              size="small"
              items={[
                { key: 1, label: 'Detalle1:', children: unitFormData?.unidad_detalle1, span: 2 },
                { key: 2, label: 'Detalle2:', children: unitFormData?.unidad_detalle2, span: 2 },
                { key: 3, label: 'Detalle3:', children: unitFormData?.unidad_detalle3, span: 2 },
                { key: 4, label: 'Detalle4:', children: unitFormData?.unidad_detalle4, span: 2 },
              ]}
            />
            <br />
            <Descriptions
              bordered
              column={4}
              title="Información Formulario"
              size="small"
              items={[
                { key: 1, label: 'Código:', children: unitFormData?.formulario_codigo, span: 2 },
                { key: 2, label: 'Categoría:', children: unitFormData?.formulario_categoria, span: 2 },
                { key: 3, label: 'Nombre:', children: unitFormData?.formulario_nombre, span: 'filled' },
              ]}
            />
          </SpinLoad>
        </Col>
      </Row>
      <Row style={{ marginTop: '30px' }} justify={'center'}>
        <Col>
          {contextHolder}
          <Button
            type="primary"
            icon={<PlusCircleOutlined />}
            disabled={disableCreation}
            onClick={() => createFillOut()}
          >Crear Nuevo Diligenciamiento</Button>
        </Col>
      </Row>
      <Row>
        <Col span={24}>
          <SpinLoad loading={loadingFillOut}>
            <Table
              columns={columnsFillOutForm}
              dataSource={dataFillOut}
              pagination={false}
              scroll={{ x: 'max-content' }}
            />
          </SpinLoad>
        </Col>
      </Row>
    </Content>
  );
}
